import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-emerald-600 to-emerald-700 rounded-lg flex items-center justify-center text-white font-bold text-xl">
                MZ
              </div>
              <div>
                <h3 className="text-lg font-bold leading-tight">Maulana Zubair Divine</h3>
                <p className="text-sm text-slate-400">School of Motoring (DSM)</p>
              </div>
            </div>
            <p className="text-slate-400 mb-4">
              Professional driving instruction in Coventry since 2002. Helping learners achieve safe driving for life.
            </p>
            <div className="flex gap-4">
              <a href="https://www.youtube.com/@MaulanaZubairDivineSchoolOfMotoring" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors duration-200">
                <Youtube className="w-5 h-5" />
              </a>
              <a href="https://www.tiktok.com/@divineschoolofmotoringmaulanazubair" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-slate-700 rounded-lg flex items-center justify-center transition-colors duration-200">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/divineschoolofmotoring" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors duration-200">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.instagram.com/dsmcoventry" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors duration-200">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-emerald-400 transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-slate-400 hover:text-emerald-400 transition-colors duration-200">
                  Testimonials
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-slate-400 hover:text-emerald-400 transition-colors duration-200">
                  Resources
                </Link>
              </li>
              <li>
                <a href="https://www.gov.uk/government/organisations/driver-and-vehicle-standards-agency" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-emerald-400 transition-colors duration-200">
                  DVSA
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-1" />
                <a href="tel:07834618908" className="text-slate-400 hover:text-emerald-400 transition-colors duration-200">
                  07834 618908
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-1" />
                <a href="mailto:zubairapabhai@gmail.com" className="text-slate-400 hover:text-emerald-400 transition-colors duration-200 break-all">
                  zubairapabhai@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-1" />
                <span className="text-slate-400">Coventry, UK</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Maulana Zubair Divine School of Motoring (DSM). All rights reserved.</p>
          <p className="mt-2">Competitively priced lessons | Over 1000+ pupils passed since 2002</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
